import { Controller } from "@hotwired/stimulus"

export function documentSelectionState(checkboxes) {
  const totalCount = checkboxes.length
  const selectedCount = checkboxes.filter(checkbox => checkbox.checked).length

  return {
    totalCount,
    selectedCount,
    allSelected: totalCount > 0 && selectedCount === totalCount,
    someSelected: selectedCount > 0 && selectedCount < totalCount
  }
}

export default class extends Controller {
  static targets = [
    "checkbox",
    "submit",
    "count",
    "defaultActions",
    "managementActions",
    "manageTrigger",
    "selectAll"
  ]

  connect() {
    this.element.classList.add("document-selection-ready")
    this.setManaging(false)
  }

  startManaging() {
    this.setManaging(true)
    window.requestAnimationFrame(() => this.selectAllTarget.focus())
  }

  stopManaging() {
    this.setManaging(false)
    window.requestAnimationFrame(() => this.manageTriggerTarget.focus())
  }

  toggleAll(event) {
    this.checkboxTargets.forEach(checkbox => {
      checkbox.checked = event.currentTarget.checked
    })
    this.sync()
  }

  sync() {
    const state = documentSelectionState(this.checkboxTargets)

    if (this.hasSubmitTarget) this.submitTarget.disabled = state.selectedCount === 0
    if (this.hasCountTarget) {
      this.countTarget.textContent = this.managing
        ? `${state.selectedCount} selected on this page`
        : ""
    }
    if (this.hasSelectAllTarget) {
      this.selectAllTarget.checked = state.allSelected
      this.selectAllTarget.indeterminate = state.someSelected
    }
  }

  setManaging(managing) {
    this.managing = managing
    this.element.classList.toggle("is-managing", managing)
    this.defaultActionsTarget.hidden = managing
    if (this.hasManagementActionsTarget) this.managementActionsTarget.hidden = !managing

    this.checkboxTargets.forEach(checkbox => {
      checkbox.hidden = !managing
      if (!managing) checkbox.checked = false
    })
    this.sync()
  }
}
